import {
  CreateNotificationSink,
  NotificationSink,
  NotificationSinkMin,
  NotificationSinkConnector,
  NotificationSinkConnectorType,
  LinkNotificationSink,
  LinkedNotificationSinkMin,
  NotificationSinkConfig,
  UpdateNotificationSink,
  ExternalAuthorizationId,
  NotificationSinkId,
} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function listConnectors(): Promise<NotificationSinkConnector[]> {
  return await platformedClient.internalRequest("get", `/region/{region}/api/notification_channel_connectors`, {});
}

export async function getConnector(connectorType: NotificationSinkConnectorType): Promise<NotificationSinkConnector> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/notification_channel_connectors/{notification_channel_connector_type}`,
    {path: {notification_channel_connector_type: connectorType}},
  );
}

export async function getDefaultConfig(
  connectorType: NotificationSinkConnectorType,
  externalAuthorizationId: ExternalAuthorizationId,
): Promise<NotificationSinkConfig> {
  return await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/notification_channel_connectors/{notification_channel_connector_type}/default_config`,
    {body: externalAuthorizationId, path: {notification_channel_connector_type: connectorType}},
  );
}

export async function create(payload: CreateNotificationSink): Promise<NotificationSink> {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/notification_channels`, {
    body: payload,
  });
  await invalidateQueries([q.notificationChannels.filter()]);
  return res;
}

export async function update(channelId: NotificationSinkId, payload: UpdateNotificationSink) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/notification_channels/{notification_sink_id}`,
    {body: payload, path: {notification_sink_id: channelId}},
  );
  await invalidateQueries([q.notificationChannels.filter(), q.notificationChannel.filter(channelId)]);
  return res;
}

export async function delete_(channelId: NotificationSinkId) {
  const res = await platformedClient.internalRequest(
    "delete",
    `/region/{region}/api/notification_channels/{notification_sink_id}`,
    {path: {notification_sink_id: channelId}},
  );
  await invalidateQueries([q.notificationChannels.filter(), q.notificationChannel.filter(channelId)]);
  return res;
}

export async function updateName(channelId: NotificationSinkId, name: string) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/notification_channels/{notification_sink_id}/name`,
    {body: name, path: {notification_sink_id: channelId}},
  );
  await invalidateQueries([q.notificationChannels.filter(), q.notificationChannel.filter(channelId)]);
  return res;
}

export async function list(): Promise<NotificationSinkMin[]> {
  return await platformedClient.internalRequest("get", `/region/{region}/api/notification_channels`, {});
}

export async function get(channelId: NotificationSinkId): Promise<NotificationSink> {
  return await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/notification_channels/{notification_sink_id}`,
    {path: {notification_sink_id: channelId}},
  );
}

export async function listAvailable(): Promise<NotificationSinkMin[]> {
  return await platformedClient.internalRequest("get", `/region/{region}/api/available_notification_channels`, {});
}

export async function linkChannel(link: LinkNotificationSink): Promise<LinkedNotificationSinkMin> {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/user_notification_channels`, {
    body: link,
  });
  await invalidateQueries([q.availableNotificationChannels.filter(), q.linkedNotificationChannels.filter()]);
  return res;
}

export async function listLinked(): Promise<LinkedNotificationSinkMin[]> {
  return await platformedClient.internalRequest("get", `/region/{region}/api/user_notification_channels`, {});
}

export async function deleteLinked(channelId: NotificationSinkId) {
  const res = await platformedClient.internalRequest(
    "delete",
    `/region/{region}/api/user_notification_channels/{notification_sink_id}`,
    {path: {notification_sink_id: channelId}},
  );
  await invalidateQueries([q.availableNotificationChannels.filter(), q.linkedNotificationChannels.filter()]);
  return res;
}
